import {
    configureStore,
    Store
} from '@reduxjs/toolkit';

import {AccountsReducer} from '../features/accounts/reducers';
import {AccountApplicationsReducer} from '../features/account-applications/reducers';
import {ApplicationAccountsReducer} from '../features/application-accounts/reducers';
import {ApplicationProductsReducer} from '../features/application-products/reducers';
import {ApplicationScreenshotsReducer} from '../features/application-screenshots/reducers';
import {ApplicationsReducer} from '../features/applications/reducers';
import {OrganizationAccountsReducer} from '../features/organization-accounts/reducers';
import {OrganizationsReducer} from '../features/organizations/reducers';
import {PhasesReducer} from '../features/phases/reducers';
import {PlaybooksReducer} from '../features/playbooks/reducers';
import {ProductsReducer} from '../features/products/reducers';
import {StepsReducer} from '../features/steps/reducers';
import {UsersReducer} from '../features/users/reducers';

// Row selection state (FNP-951). Records are React Query's job; selection is Redux's.
const reducers = {
    'accounts': AccountsReducer,
    'account-applications': AccountApplicationsReducer,
    'application-accounts': ApplicationAccountsReducer,
    'application-products': ApplicationProductsReducer,
    'application-screenshots': ApplicationScreenshotsReducer,
    'applications': ApplicationsReducer,
    'organization-accounts': OrganizationAccountsReducer,
    'organizations': OrganizationsReducer,
    'phases': PhasesReducer,
    'playbooks': PlaybooksReducer,
    'products': ProductsReducer,
    'steps': StepsReducer,
    'users': UsersReducer,
};

// added this middleware  to disable this error - A non-serializable value was detected in the state, in the path...
// @todo disable if better way is found
export const store: Store = configureStore({
                                               reducer: reducers,
                                               middleware: (getDefaultMiddleware) =>
                                                   getDefaultMiddleware({
                                                                            serializableCheck: false,
                                                                        }),
                                           });


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch